// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-message {
  position: relative;
  display: flex;
  align-items: flex-start;
  height: auto;
  background-color: rgb(var(--colour-elevation-1, 255, 255, 255));
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 0 solid rgb(var(--colour-elevation-1-border, 223, 223, 223));
  border-inline-start-width: 0.25rem;
  padding: 1rem 0;
  padding-inline-end: 0.5rem;
  min-height: 1.5rem;
  text-align: start;
  font-size: 0.875rem;
  box-sizing: border-box;
}
.inline-message a {
  text-decoration: underline;
}
.inline-message__content {
  width: 100%;
  padding-inline-end: 1.5rem;
}
.inline-message__body {
  line-height: 1.571;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  font-size: 0.875rem;
  margin: 0;
}
.inline-message__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.inline-message__actions .btn:last-child {
  margin-inline-start: 0.25rem;
}
.inline-message__close-button {
  margin-top: -0.5rem;
}
.inline-message__title {
  line-height: 1.571;
  font-size: 0.875rem;
  font-weight: 700;
  padding-bottom: 0.25rem;
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  margin: 0;
}
.inline-message__icon {
  flex-shrink: 0;
  margin-inline-start: 0.75rem;
  margin-inline-end: 0.75rem;
}
.inline-message--dismissable .inline-message__content {
  padding-inline-end: 0.5rem;
}
.inline-message--icon-hidden {
  padding-inline-start: 0.75rem;
}
.inline-message--subtle {
  border: 0;
  box-shadow: none;
  padding: 0;
  overflow: visible;
  background: none;
}
.inline-message--subtle .inline-message__close-button {
  margin-top: -0.25rem;
}
.inline-message--subtle .inline-message__icon {
  margin-inline-start: 0;
}
.inline-message--closed {
  transition: all 200ms cubic-bezier(0.4, 0, 0.4, 1);
  padding-top: 0;
  padding-bottom: 0;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  min-height: 0;
}
.inline-message--collapsed {
  display: none;
}
.inline-message--informative {
  border-inline-start-color: rgb(var(--colour-semantic-informative, 0, 88, 163));
}
.inline-message--informative .inline-message__icon {
  color: rgb(var(--colour-semantic-informative, 0, 88, 163));
}
.inline-message--positive {
  border-inline-start-color: rgb(var(--colour-semantic-positive, 10, 138, 0));
}
.inline-message--positive .inline-message__icon {
  color: rgb(var(--colour-semantic-positive, 10, 138, 0));
}
.inline-message--cautionary {
  border-inline-start-color: rgb(var(--colour-semantic-caution, 242, 106, 47));
}
.inline-message--cautionary .inline-message__icon {
  color: rgb(var(--colour-semantic-caution, 242, 106, 47));
}
.inline-message--negative {
  border-inline-start-color: rgb(var(--colour-semantic-negative, 224, 7, 81));
}
.inline-message--negative .inline-message__icon {
  color: rgb(var(--colour-semantic-negative, 224, 7, 81));
}

@media (prefers-contrast: more) {
  .inline-message {
    border-block-start-width: 1px;
    border-block-end-width: 1px;
    border-inline-end-width: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/inline-message/dist/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,+DAA+D;EAC/D,2CAA2C;EAC3C,kBAAkB;EAClB,oEAAoE;EACpE,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qDAAqD;EACrD,SAAS;AACX;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kDAAkD;EAClD,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,8EAA8E;AAChF;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,uDAAuD;AACzD;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF","sourcesContent":[".inline-message {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  height: auto;\n  background-color: rgb(var(--colour-elevation-1, 255, 255, 255));\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  border: 0 solid rgb(var(--colour-elevation-1-border, 223, 223, 223));\n  border-inline-start-width: 0.25rem;\n  padding: 1rem 0;\n  padding-inline-end: 0.5rem;\n  min-height: 1.5rem;\n  text-align: start;\n  font-size: 0.875rem;\n  box-sizing: border-box;\n}\n.inline-message a {\n  text-decoration: underline;\n}\n.inline-message__content {\n  width: 100%;\n  padding-inline-end: 1.5rem;\n}\n.inline-message__body {\n  line-height: 1.571;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  font-size: 0.875rem;\n  margin: 0;\n}\n.inline-message__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n}\n.inline-message__actions .btn:last-child {\n  margin-inline-start: 0.25rem;\n}\n.inline-message__close-button {\n  margin-top: -0.5rem;\n}\n.inline-message__title {\n  line-height: 1.571;\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding-bottom: 0.25rem;\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  margin: 0;\n}\n.inline-message__icon {\n  flex-shrink: 0;\n  margin-inline-start: 0.75rem;\n  margin-inline-end: 0.75rem;\n}\n.inline-message--dismissable .inline-message__content {\n  padding-inline-end: 0.5rem;\n}\n.inline-message--icon-hidden {\n  padding-inline-start: 0.75rem;\n}\n.inline-message--subtle {\n  border: 0;\n  box-shadow: none;\n  padding: 0;\n  overflow: visible;\n  background: none;\n}\n.inline-message--subtle .inline-message__close-button {\n  margin-top: -0.25rem;\n}\n.inline-message--subtle .inline-message__icon {\n  margin-inline-start: 0;\n}\n.inline-message--closed {\n  transition: all 200ms cubic-bezier(0.4, 0, 0.4, 1);\n  padding-top: 0;\n  padding-bottom: 0;\n  visibility: hidden;\n  opacity: 0;\n  overflow: hidden;\n  min-height: 0;\n}\n.inline-message--collapsed {\n  display: none;\n}\n.inline-message--informative {\n  border-inline-start-color: rgb(var(--colour-semantic-informative, 0, 88, 163));\n}\n.inline-message--informative .inline-message__icon {\n  color: rgb(var(--colour-semantic-informative, 0, 88, 163));\n}\n.inline-message--positive {\n  border-inline-start-color: rgb(var(--colour-semantic-positive, 10, 138, 0));\n}\n.inline-message--positive .inline-message__icon {\n  color: rgb(var(--colour-semantic-positive, 10, 138, 0));\n}\n.inline-message--cautionary {\n  border-inline-start-color: rgb(var(--colour-semantic-caution, 242, 106, 47));\n}\n.inline-message--cautionary .inline-message__icon {\n  color: rgb(var(--colour-semantic-caution, 242, 106, 47));\n}\n.inline-message--negative {\n  border-inline-start-color: rgb(var(--colour-semantic-negative, 224, 7, 81));\n}\n.inline-message--negative .inline-message__icon {\n  color: rgb(var(--colour-semantic-negative, 224, 7, 81));\n}\n\n@media (prefers-contrast: more) {\n  .inline-message {\n    border-block-start-width: 1px;\n    border-block-end-width: 1px;\n    border-inline-end-width: 1px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
